export default {
  trends: {
    filters: {
      title: "Filter",
      trends: "Trends",
      allTrends: "Alle Trends",
      displayGames: "Spiele anzeigen",
      alternateLines: "Alternative Linien",
    },
    list: {
      empty: {
        noPropsAvailable: "Keine Props verfügbar",
        noTrendsAvailableYet: "Noch keine Trends verfügbar",
        needsThreeGamesMinimum: "Mindestens 3 Spiele erforderlich",
        pendingOddsCheckBack: "Quoten ausstehend. Bitte später erneut prüfen.",
      },
      preview: {
        comboTrendPreview: "Combo-Trend-Vorschau",
        tryLinematePlus: "Linemate+ testen",
      },
      actions: {
        addAllLegsToMyPicks: "Alle Legs zu Meine Tipps hinzufügen",
      },
    },
    cheatsheet: {
      title: "Cheatsheet",
      separator: {
        noLongerHundredPercent: "UNTERHALB NICHT MEHR 100%",
      },
    },
    details: {
      labels: {
        trendsInThisParlay: "Trends in dieser Kombiwette",
        straights: "Einzelwetten",
        all: "Alle",
        hitRates: "Trefferquoten",
        perGame: "Pro Spiel",
        against: "gegen",
        rank: "Rang",
        pitcher: "Pitcher",
        handedness: "Wurfhand",
        defensiveRanking: "Defensivrang",
      },
      actions: {
        addAllPicksAsParlay: "Alle Tipps als Kombiwette hinzufügen",
        removeAll: "Alle entfernen",
      },
    },
  },
};
